import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { Gallery } from './pages/Gallery';
import { Payment } from './pages/Payment';
import { About } from './pages/About';
import { Membership } from './pages/Membership';
import { Legal } from './pages/Legal';
import { ScrollToTop } from './components/ScrollToTop';
import { Success } from './pages/Success';
import { SEO } from './components/SEO';
import { WhatsAppButton } from './components/WhatsAppButton';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <SEO title="Accueil" />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/evenements" element={<Events />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/payment/:eventId" element={<Payment />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/devenir-membre" element={<Membership />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/success" element={<Success />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;